(function () {
  var fmt = function (paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toast = $('#toast');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 1800);
  }

  /* ---------- Header toggles ---------- */
  var searchBar = $('#searchBar');
  var searchToggle = $('#searchToggle');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('open');
      if (searchBar.classList.contains('open')) $('input', searchBar).focus();
    });
  }
  var mobileMenu = $('#mobileMenu');
  var menuToggle = $('#menuToggle');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () { mobileMenu.classList.toggle('open'); });
  }

  /* ---------- Cart drawer ---------- */
  var overlay = $('#overlay');
  var drawer = $('#cartDrawer');
  var bagCount = $('#bagCount');
  var drawerItems = $('#drawerItems');
  var subtotalEl = $('#subtotal');

  function openDrawer() { if (drawer) { drawer.classList.add('active'); overlay.classList.add('active'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('active'); overlay.classList.remove('active'); } }

  var cartToggle = $('#cartToggle');
  if (cartToggle) cartToggle.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  var drawerClose = $('#drawerClose');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function renderCart(cart) {
    if (bagCount) bagCount.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = fmt(cart.items_subtotal_price);
    if (!drawerItems) return;
    if (cart.item_count === 0) {
      drawerItems.innerHTML =
        '<div class="drawer-empty">' +
        '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 016 0v2"/></svg>' +
        '<p>Your bag is empty.</p><p style="font-size:12px;">Go find something good.</p></div>';
      return;
    }
    drawerItems.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x120$1$2') + '" alt="" loading="lazy">'
        : '';
      return '<div class="drawer-item">' +
        '<div class="di-visual">' + img + '</div>' +
        '<div class="di-info">' +
        '<h4><a href="' + item.url + '">' + item.product_title + '</a></h4>' +
        '<div class="di-price">' + fmt(item.final_price) + ' × ' + item.quantity + '</div>' +
        '<div class="di-qty">' +
        '<button data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
        '<button class="di-remove" data-action="remove" data-key="' + item.key + '">Remove</button>' +
        '</div></div></div>';
    }).join('');
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawerItems) {
    drawerItems.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-action]');
      if (!btn) return;
      var key = btn.dataset.key;
      var qty = Number(btn.dataset.qty || 0);
      if (btn.dataset.action === 'inc') changeQty(key, qty + 1);
      if (btn.dataset.action === 'dec') changeQty(key, qty - 1);
      if (btn.dataset.action === 'remove') changeQty(key, 0);
    });
  }

  window.MDAddToCart = function (variantId, qty, title) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to bag'); });
      return r.json();
    }).then(function () {
      return refreshCart().then(function () {
        showToast((title || 'Item') + ' added to bag');
        openDrawer();
      });
    }).catch(function (err) { showToast(err.message); });
  };

  /* Quick add buttons on product cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    window.MDAddToCart(btn.dataset.variantId, 1, btn.dataset.title);
  });

  /* ---------- Homepage category filters ---------- */
  var filtersBar = $('#filters');
  var grid = $('#productGrid');
  if (filtersBar && grid) {
    filtersBar.addEventListener('click', function (e) {
      var btn = e.target.closest('.pill');
      if (!btn) return;
      $$('.pill', filtersBar).forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var f = btn.dataset.filter;
      var visible = 0;
      $$('.card', grid).forEach(function (card) {
        var cats = (card.dataset.collections || '').split(',');
        var show = f === 'all' || cats.indexOf(f) !== -1;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      var empty = $('.empty-grid', grid);
      if (empty) empty.style.display = visible === 0 ? '' : 'none';
    });
  }

  /* ---------- Homepage video showcase (random 4-up desktop / 2-up mobile, 9:16) ---------- */
  (function () {
    var vsGrid = $('#vsGrid');
    if (!vsGrid) return;

    var vsVideos = [];
    try { vsVideos = JSON.parse(vsGrid.dataset.videos || '[]'); } catch (e) { vsVideos = []; }
    vsVideos = vsVideos.filter(function (v) { return v && v.src; });

    var allSlots = $$('.vs-slot', vsGrid);
    var refreshBtn = $('#vsRefresh');

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
      }
      return a;
    }

    function visibleSlots() {
      return allSlots.filter(function (slot) {
        return slot.offsetParent !== null && getComputedStyle(slot).display !== 'none';
      });
    }

    function pickVideo(exclude) {
      if (!vsVideos.length) return null;
      if (vsVideos.length === 1) return vsVideos[0];
      var pool = vsVideos.filter(function (v) { return v.src !== exclude; });
      if (!pool.length) pool = vsVideos;
      return pool[Math.floor(Math.random() * pool.length)];
    }

    function buildProductCard(pick) {
      var card = document.createElement('a');
      card.className = 'vs-pcard';
      card.href = pick.productUrl;
      card.setAttribute('aria-label', 'View ' + pick.productTitle);
      var imgHtml = pick.productImage
        ? '<img src="' + pick.productImage + '" alt="" loading="lazy">'
        : '';
      card.innerHTML =
        imgHtml +
        '<div class="vs-pcard-info">' +
        '<div class="vs-pcard-title">' + pick.productTitle + '</div>' +
        '<div class="vs-pcard-meta">' +
        '<span class="vs-pcard-stars">★★★★★</span>' +
        (pick.productPrice ? '<span class="vs-pcard-price">' + pick.productPrice + '</span>' : '') +
        '</div></div>';
      card.addEventListener('click', function (e) { e.stopPropagation(); });
      return card;
    }

    function loadSlot(slot, pick) {
      var frame = $('.vs-frame', slot);
      var video = $('video', frame);
      if (!pick || !video) return;
      var oldLabel = $('.vs-label', frame);
      if (oldLabel) oldLabel.remove();
      var oldCard = $('.vs-pcard', frame);
      if (oldCard) oldCard.remove();
      video.classList.remove('vs-ready');
      video.src = pick.src;
      video.dataset.currentSrc = pick.src;
      video.load();
      video.oncanplay = function () { video.classList.add('vs-ready'); };
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});

      if (pick.productUrl && pick.productTitle) {
        frame.appendChild(buildProductCard(pick));
        slot.onclick = null;
        slot.style.cursor = '';
      } else {
        if (pick.label) {
          var label = document.createElement('span');
          label.className = 'vs-label';
          label.textContent = pick.label;
          frame.appendChild(label);
        }
        slot.onclick = pick.link ? function () { window.location.href = pick.link; } : null;
        slot.style.cursor = pick.link ? 'pointer' : '';
      }

      video.onended = function () {
        loadSlot(slot, pickVideo(video.dataset.currentSrc));
      };
    }

    function renderShowcase() {
      if (!vsVideos.length) {
        vsGrid.innerHTML = '<div class="vs-empty">Videos coming soon.</div>';
        return;
      }
      var slots = visibleSlots();
      var picks = shuffle(vsVideos).slice(0, slots.length);
      while (picks.length < slots.length) {
        picks = picks.concat(shuffle(vsVideos)).slice(0, slots.length);
      }
      slots.forEach(function (slot, i) { loadSlot(slot, picks[i]); });
    }

    renderShowcase();

    if (refreshBtn) {
      refreshBtn.addEventListener('click', function () {
        refreshBtn.classList.add('spinning');
        renderShowcase();
        setTimeout(function () { refreshBtn.classList.remove('spinning'); }, 450);
      });
    }

    /* Re-check visible slot count on breakpoint changes (mobile <-> desktop) */
    var vsResizeTimer;
    var lastVisibleCount = visibleSlots().length;
    window.addEventListener('resize', function () {
      clearTimeout(vsResizeTimer);
      vsResizeTimer = setTimeout(function () {
        var count = visibleSlots().length;
        if (count !== lastVisibleCount) {
          lastVisibleCount = count;
          renderShowcase();
        }
      }, 200);
    });
  })();

  /* ---------- PDP ---------- */
  var pdpForm = $('#pdpForm');
  var pdpThumbButtons = $$('.pdp-thumbs button');

  /* Keep the standard Buy Now product-form(s) in sync with the selected variant + qty.
     Buy Now now submits as a real Shopify product form (name="checkout"), instead of a
     JS fetch+redirect, so that checkout/COD apps (e.g. PenguinCOD) can detect and
     intercept the click the normal way they're built to. */
  function syncBuyNowForms() {
    var variantSelect = $('#variantSelect');
    var qtyInput = $('#pdpQty');
    var id = variantSelect ? variantSelect.value : (pdpForm && pdpForm.dataset.variantId);
    var qty = (qtyInput && Number(qtyInput.value)) || 1;
    $$('.pdp-buy-now-form').forEach(function (f) {
      var idField = $('input[name="id"]', f);
      var qtyField = $('input[name="quantity"]', f);
      if (idField) idField.value = id;
      if (qtyField) qtyField.value = qty;
      var btn = $('button[name="checkout"]', f);
      if (btn) btn.dataset.variantId = id;
    });
  }

  if (pdpForm) {
    var variantSelect = $('#variantSelect');
    var qtyInput = $('#pdpQty');
    $$('.qty-box button', pdpForm).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var v = Number(qtyInput.value) + (b.dataset.dir === 'up' ? 1 : -1);
        qtyInput.value = Math.max(1, v);
        syncBuyNowForms();
      });
    });
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        var priceEl = $('#pdpPrice');
        if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.priceHtml || opt.dataset.price;
        var btn = $('#pdpAddBtn');
        if (btn) {
          var avail = opt.dataset.available === 'true';
          btn.disabled = !avail;
          btn.textContent = avail ? btn.dataset.labelAdd : 'Sold out';
        }
        syncBuyNowForms();
      });
    }
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = variantSelect ? variantSelect.value : pdpForm.dataset.variantId;
      window.MDAddToCart(id, Number(qtyInput.value) || 1, pdpForm.dataset.title);
    });
    syncBuyNowForms();
  }

  /* ---------- PDP image gallery + fullscreen swipe lightbox ---------- */
  var pdpMainImg = $('#pdpMainImg');
  var lightbox = $('#pdpLightbox');
  var lightboxTrack = $('#pdpLightboxTrack');
  var lightboxSlides = lightbox ? $$('.pdp-lightbox-slide', lightbox) : [];
  var lightboxCounter = $('#pdpLightboxCounter');
  var lightboxIndex = 0;

  function updateLightboxCounter() {
    if (lightboxCounter && lightboxSlides.length) {
      lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + lightboxSlides.length;
    }
  }

  function goToLightboxSlide(i, smooth) {
    if (!lightboxTrack || !lightboxSlides.length) return;
    lightboxIndex = (i + lightboxSlides.length) % lightboxSlides.length;
    var target = lightboxSlides[lightboxIndex];
    lightboxTrack.scrollTo({ left: target.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    updateLightboxCounter();
  }

  function openLightbox(startIndex) {
    if (!lightbox || !lightboxSlides.length) return;
    lightbox.classList.add('active');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pdp-lightbox-open');
    goToLightboxSlide(startIndex || 0, false);
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('active');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pdp-lightbox-open');
  }

  if (pdpMainImg && lightbox) {
    pdpMainImg.addEventListener('click', function () {
      var activeThumb = $('.pdp-thumbs button.active');
      var idx = activeThumb ? Number(activeThumb.dataset.index || 0) : 0;
      openLightbox(idx);
    });
    pdpMainImg.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pdpMainImg.click(); }
    });
  }

  var lbClose = lightbox ? $('.pdp-lightbox-close', lightbox) : null;
  var lbPrev = lightbox ? $('.pdp-lightbox-nav.prev', lightbox) : null;
  var lbNext = lightbox ? $('.pdp-lightbox-nav.next', lightbox) : null;
  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lbPrev) lbPrev.addEventListener('click', function () { goToLightboxSlide(lightboxIndex - 1); });
  if (lbNext) lbNext.addEventListener('click', function () { goToLightboxSlide(lightboxIndex + 1); });
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('active')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') goToLightboxSlide(lightboxIndex - 1);
    if (e.key === 'ArrowRight') goToLightboxSlide(lightboxIndex + 1);
  });
  /* Keep counter/index in sync while the user swipes/scrolls manually */
  if (lightboxTrack) {
    var scrollTimer;
    lightboxTrack.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var scrollLeft = lightboxTrack.scrollLeft;
        var closest = 0;
        var closestDist = Infinity;
        lightboxSlides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - scrollLeft);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        lightboxIndex = closest;
        updateLightboxCounter();
      }, 100);
    });
  }

  pdpThumbButtons.forEach(function (t) {
    t.addEventListener('click', function () {
      pdpThumbButtons.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var main = $('#pdpMainImg');
      if (main) main.src = t.dataset.full;
    });
  });

  /* ---------- Collection sort ---------- */
  var sortSelect = $('#sortSelect');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  refreshCart();
})();
